import { useEffect, useState, FC } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

//Services
import { createLocation, getLocationById, updateLocation } from '../../services/LocationService';

//Components
import { Button, Container, Form } from 'react-bootstrap';
import ActivityLoading from '../common/ActivityLoading';
import ActivityToast from '../common/ActivityToast';

//Types
import { LocationInterface, /* GroupInterface, */ ToastOptionsInterface } from '../common/Types';

//Styles
import '../common/styles.scss';

const schema = yup.object().shape({
    name: yup.string().required("El campo 'Nombre' es requerido"),
    description: yup.string().required("El campo 'Descripción' es requerido"),
});

const defaultValues: any = {
    name: "",
    description: "",
};

const Location: FC = (props: any) => {
    const { location } = props;

    const [action, setAction] = useState("create");
    const [loading, setLoading] = useState(false);
    const [locationSelected, setLocationSelected] = useState<LocationInterface | undefined>(undefined);
    const [toastOptions, setToastOptions] = useState<ToastOptionsInterface>({ open: false, message: "" });

    const history = useHistory();

    const { control, setValue, formState, handleSubmit } = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    });
    const { errors } = formState;

    useEffect(() => {
        setLoading(true);

        const locationSplit = location.pathname.split('/')
        if (locationSplit[2] === "edit") {
            setAction("update")
            fetchLocation(locationSplit[3]);
        } else {
            setLocationSelected({} as LocationInterface);
        }
    }, [location])

    useEffect(() => {
        if (locationSelected) {

            setValue('name', locationSelected.name ? locationSelected.name : "");
            setValue('description', locationSelected.description ? locationSelected.description : "");
            setLoading(false)
        }
    }, [locationSelected, setValue])

    const onSubmit = (locationData: LocationInterface) => {
        setLoading(true);

        const payload: LocationInterface = {
            name: locationData.name,
            description: locationData.description,
            deleted: false
        }

        if (action === "update" && locationSelected) {
            updateLocation(locationSelected.id, payload)
                .then((response: string) => {
                    if (response !== "error") {
                        history.push({ pathname: `/locations` })
                    } else {
                        setToastOptions({ open: true, message: "Ha ocurrido un error" })
                        setLoading(false)
                    }
                });
        } else {
            createLocation(payload).then((response: string) => {
                if (response !== "error") {
                    history.push({ pathname: `/locations` })
                } else {
                    setToastOptions({ open: true, message: "Ha ocurrido un error" })
                    setLoading(false)
                }
            });
        }
    }

    const fetchLocation = (locationId: string) => {
        if (!locationId || locationId === "error") {
            setToastOptions({ open: true, message: "Ha ocurrido un error" })
            setLoading(false)
            return;
        }

        getLocationById(locationId).then((response: any) => {
            setLocationSelected(response as LocationInterface)
        })
    }

    const handleToastClose = (data: any) => {
        setToastOptions({ open: false, message: "" });
    }

    if (loading) {
        return <ActivityLoading />
    }

    return (
        <Container>
            <ActivityToast {...toastOptions} onClose={handleToastClose} autohide={4000} />
            <div style={{ marginBottom: '10px' }}>
                <h1>Ubicación</h1>
            </div>
            <Button
                type="submit"
                variant="outline-primary"
                aria-label="save"
                className="return-button"
                onClick={() => history.goBack()}
            >
                {`Regresar`}
            </Button>
            <form className="flex flex-col justify-center w-full" onSubmit={handleSubmit(onSubmit)}>
                <Controller
                    name="name"
                    control={control}
                    render={({ field }) => (
                        <Form.Group controlId="locationName">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control
                                {...field}
                                isInvalid={!!errors.name}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors?.name?.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    )}
                />
                <Controller
                    name="description"
                    control={control}
                    render={({ field }) => (
                        <Form.Group controlId="locationName">
                            <Form.Label>Descripción</Form.Label>
                            <Form.Control
                                {...field}
                                isInvalid={!!errors.description}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors?.description?.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    )}
                />
                <Button
                    type="submit"
                    variant="primary"
                    aria-label="save"
                >
                    {`Guardar ubicación`}
                </Button>
            </form>
        </Container>
    )
}

export default Location;
